import { getInstoreOrderStatus } from "../services/orderService";
import { appendQuery } from "./urlHelper";
import { _3dsStatus } from "./lynkco-constants";

let watchOrderTimeout;
export const startWatchOrder = async ({ redirect, orderId, orderNo, onSuccess, onError }) => {
  let orderState = await getInstoreOrderStatus(orderNo);
  const { status } = orderState?.obj?.paymentTransaction || {};
  if (orderState.code !== "1") {
    stopWatchOrder();
    onError && onError({ code: orderState?.code });
  } else if (status === _3dsStatus.successNoLink || status === _3dsStatus.parSaleLoading) {
    stopWatchOrder();
    onSuccess && onSuccess();
    window.location.href = appendQuery(redirect, {
      orderId,
      orderNo
    });
  } else if (status === _3dsStatus.pendingHasLink) {
    watchOrderTimeout = setTimeout(startWatchOrder, 5000, { redirect, orderId, orderNo, onSuccess, onError });
  } else if (status === _3dsStatus.failed || status === _3dsStatus.orderCanceled) {
    stopWatchOrder();
    onError && onError({ code: orderState?.obj?.paymentTransaction?.status });
  }
};
export const stopWatchOrder = () => {
  if (watchOrderTimeout) {
    clearTimeout(watchOrderTimeout);
  }
};
